import { ContractStep, ContractStepsNames } from "../contractSteps";

import { Contract } from "@/components/Contracts/contract.interface";
import { ServicesCategoriesTypesEnum } from "@/modules/Settings/types/ServicesCategories.types";

export function shouldHavePaymentMethod(
  contract: Contract,
  currentStep?: ContractStep
): boolean {
  const isTagCategory =
    contract?.serviceCategory?.type === ServicesCategoriesTypesEnum.TAG;

  if (isTagCategory) {
    const hasOfferPricePaymentMethod = contract?.items?.some(
      item => item?.offerPrice?.offerPricePaymentMethod?.length > 0
    );

    if (!hasOfferPricePaymentMethod) {
      return false;
    }
  }

  if (
    currentStep?.name === ContractStepsNames.DOCUMENTOS_COMPLEMENTARES ||
    currentStep?.name === ContractStepsNames.METODO_DE_PAGAMENTO ||
    currentStep?.name === ContractStepsNames.CONFIRMACAO
  ) {
    return !contract?.setupPaymentMethodId;
  }

  return true;
}
